var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGridUnselected(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.923,
    height: 20,
    viewBox: "0 0 19.923 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "grid_unselected",
    transform: "translate(-1.85)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1595",
    "data-name": "Path 1595",
    d: "M7.625.661A.66.66,0,0,0,6.964,0H2.511A.66.66,0,0,0,1.85.661V5.116a.66.66,0,0,0,.661.661H6.966a.66.66,0,0,0,.661-.661V.661Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1596",
    "data-name": "Path 1596",
    d: "M357.325.661A.66.66,0,0,0,356.664,0h-4.453a.66.66,0,0,0-.661.661V5.116a.66.66,0,0,0,.661.661h4.453a.66.66,0,0,0,.661-.661Z",
    transform: "translate(-342.627 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1597",
    "data-name": "Path 1597",
    d: "M707.025.661A.66.66,0,0,0,706.364,0h-4.453a.66.66,0,0,0-.661.661V5.116a.66.66,0,0,0,.661.661h4.455a.66.66,0,0,0,.661-.661V.661Z",
    transform: "translate(-685.254 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1598",
    "data-name": "Path 1598",
    d: "M7.625,352.261a.66.66,0,0,0-.661-.661H2.511a.66.66,0,0,0-.661.661v4.453a.66.66,0,0,0,.661.661H6.966a.66.66,0,0,0,.661-.661v-4.453Z",
    transform: "translate(0 -344.488)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1599",
    "data-name": "Path 1599",
    d: "M357.325,352.261a.66.66,0,0,0-.661-.661h-4.453a.66.66,0,0,0-.661.661v4.453a.66.66,0,0,0,.661.661h4.453a.66.66,0,0,0,.661-.661Z",
    transform: "translate(-342.627 -344.488)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1600",
    "data-name": "Path 1600",
    d: "M707.025,352.261a.66.66,0,0,0-.661-.661h-4.453a.66.66,0,0,0-.661.661v4.453a.66.66,0,0,0,.661.661h4.455a.66.66,0,0,0,.661-.661v-4.453Z",
    transform: "translate(-685.254 -344.488)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1601",
    "data-name": "Path 1601",
    d: "M6.964,703.1H2.511a.66.66,0,0,0-.661.661v4.455a.66.66,0,0,0,.661.661H6.966a.66.66,0,0,0,.661-.661v-4.455A.665.665,0,0,0,6.964,703.1Z",
    transform: "translate(0 -688.877)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1602",
    "data-name": "Path 1602",
    d: "M356.664,703.1h-4.453a.66.66,0,0,0-.661.661v4.455a.66.66,0,0,0,.661.661h4.453a.66.66,0,0,0,.661-.661v-4.455A.662.662,0,0,0,356.664,703.1Z",
    transform: "translate(-342.627 -688.877)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1603",
    "data-name": "Path 1603",
    d: "M706.364,703.1h-4.453a.66.66,0,0,0-.661.661v4.455a.66.66,0,0,0,.661.661h4.455a.66.66,0,0,0,.661-.661v-4.455A.665.665,0,0,0,706.364,703.1Z",
    transform: "translate(-685.254 -688.877)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridUnselected);
export default __webpack_public_path__ + "static/media/grid_unselected.1f5190c373ac2602e90c1cebe1de15ee.svg";
export { ForwardRef as ReactComponent };